'use strict';

var React = require('react'),
    ContextMenu = require('../molecules/ContextMenu'),
    ZineStore = require('../stores/ZineStore'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    SidebarTypes = require('../constants/SidebarTypes'),
    ModalActionCreators = require('../actions/ModalActionCreators'),
    ModalTypes = require('../constants/ModalTypes'),
    ZineActionCreators = require('../actions/ZineActionCreators'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    Link = require('../atoms/Link'),
    Counter = require('../atoms/Counter'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    AlertTypes = require('../constants/AlertTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var ZineMoreContextMenu = React.createClass({
  mixins: [createStoreMixin(ZineStore), PureRenderMixin],

  propTypes: {
    zineSlug: React.PropTypes.string.isRequired,
    isMeCurator: React.PropTypes.bool.isRequired,
    anchorRect: React.PropTypes.object.isRequired
  },

  getStateFromStores(props) {
    return {
      zine: ZineStore.get(props.zineSlug)
    };
  },

  render() {
    var items = this.props.isMeCurator ?
      this.renderCuratorItems() :
      this.renderGeneralItems();

    return (
      <ContextMenu anchorRect={this.props.anchorRect}>
        {items}
      </ContextMenu>
    );
  },

  renderCuratorItems() {
    var zine = this.state.zine;

    return [
      <Link propagateClick
            onClick={this.handlePendingClick}
            context='contextMenu'
            underline='never'
            bold>

        Submissions

        {zine.pendingCount > 0 &&
          <Counter count={zine.pendingCount} />
        }
      </Link>,

      <ContextMenu.Separator />,

      <Link propagateClick
            onClick={this.handleInviteClick}
            context='contextMenu'
            underline='never'>
        Invite Contributors
      </Link>,

      <Link propagateClick
            onClick={this.handleEditClick}
            context='contextMenu'
            underline='never'
            hideOnTablet>
        Edit Collection
      </Link>,

      <ContextMenu.Separator hideOnTablet />,

      <Link propagateClick
            onClick={this.handleDeleteClick}
            context='contextMenu'
            underline='never'
            hideOnTablet
            color='red'>
        Delete Collection
      </Link>
    ];
  },

  renderGeneralItems() {
    return [
      <Link propagateClick
            onClick={this.handleUnfollowClick}
            context='contextMenu'
            underline='never'>
        Unfollow Collection
      </Link>
    ];
  },

  handlePendingClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.ZINE_PENDING_STAMPS, {
      zineSlug: this.props.zineSlug
    });
  },

  handleInviteClick() {
    ModalActionCreators.showModal(ModalTypes.SEND_INVITE, {
      zineSlug: this.props.zineSlug
    });
  },

  handleEditClick() {
    ZineActionCreators.createZineDraftFromZine(this.state.zine);
  },

  handleDeleteClick() {
    AlertActionCreators.showAlert(AlertTypes.DELETE_ZINE, {
      zineSlug: this.props.zineSlug
    });
  },

  handleUnfollowClick() {
    ZineActionCreators.unfollowZine(this.props.zineSlug);
  }
});

module.exports = ZineMoreContextMenu;



/** WEBPACK FOOTER **
 ** ./contextMenus/ZineMoreContextMenu.jsx
 **/